var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHexagon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 59,
    viewBox: "0 0 57 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.7773 41.0938L43.7791 24.2282L44.9039 45.041L26.7773 41.0938Z",
    fill: "url(#paint0_linear_3204_5)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6002 40.9338L20.9439 17.2612L43.6623 24.0067L26.6002 40.9338Z",
    fill: "url(#paint1_linear_3204_5)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.30469 34.5508L20.7106 17.3659L26.3768 40.9733L7.30469 34.5508Z",
    fill: "url(#paint2_linear_3204_5)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.35415 34.1043L12.2499 13.2859L20.5815 17.1399L7.35415 34.1043Z",
    fill: "url(#paint3_linear_3204_5)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.49848 34.881L26.3723 41.2383L22.3741 51.7471L7.49848 34.881Z",
    fill: "url(#paint4_linear_3204_5)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0238 24.0692L50.963 24.273L45.1277 44.4744L44.0238 24.0692Z",
    fill: "url(#paint5_linear_3204_5)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.622 51.7761L26.6449 41.2082L44.5596 45.2059L22.622 51.7761Z",
    fill: "url(#paint6_linear_3204_5)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0547 17.0469L35.4143 7.35305L43.6696 23.7493L21.0547 17.0469Z",
    fill: "url(#paint7_linear_3204_5)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20.713 16.9891L12.5329 13.1462L34.8115 7.4639L20.713 16.9891Z",
    fill: "url(#paint8_linear_3204_5)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8921 23.8278L35.9545 7.87613L50.8165 24.0255L43.8921 23.8278Z",
    fill: "url(#paint9_linear_3204_5)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3204_5",
    x1: 26.7387,
    y1: 40.965,
    x2: 47.1601,
    y2: 33.6029,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54C3FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2479DE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3204_5",
    x1: 22.5006,
    y1: 29.5425,
    x2: 42.9973,
    y2: 22.1532,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54C3FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2479DE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3204_5",
    x1: 7.45868,
    y1: 34.9616,
    x2: 24.8079,
    y2: 28.707,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54C3FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2479DE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3204_5",
    x1: 4.31263,
    y1: 25.6664,
    x2: 21.4359,
    y2: 19.4933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54C3FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2479DE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3204_5",
    x1: 11.0364,
    y1: 44.7051,
    x2: 25.7199,
    y2: 39.4115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54C3FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2479DE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3204_5",
    x1: 41.8069,
    y1: 35.2632,
    x2: 53.4182,
    y2: 31.0772,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54C3FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2479DE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3204_5",
    x1: 21.3804,
    y1: 48.3239,
    x2: 42.8861,
    y2: 40.5708,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54C3FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2479DE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3204_5",
    x1: 22.7066,
    y1: 21.6087,
    x2: 40.5678,
    y2: 15.1695,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54C3FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2479DE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3204_5",
    x1: 13.6052,
    y1: 16.1404,
    x2: 35.1411,
    y2: 8.37646,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54C3FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2479DE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_3204_5",
    x1: 39.3706,
    y1: 17.387,
    x2: 47.3976,
    y2: 14.4932,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54C3FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2479DE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHexagon);
export default __webpack_public_path__ + "static/media/hexagon.d0287b61f4eb0827f5b097935c6bc38b.svg";
export { ForwardRef as ReactComponent };